<template>
    <div class="container users">
        <b-field grouped>
            <a @click="createUser" class="button is-link">
                <b-icon pack="fa" icon="plus"></b-icon>
                <span>Lag ny bruker</span>
            </a>

            <b-input v-model="filter" placeholder="Søk" type="search" icon="search" style="margin-left:auto"></b-input>
        </b-field>


        <b-table
            :data="filtered"
            :paginated="paginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :narrowed="true"
            :loading="loading"
            default-sort="user.createdAt">

            <template slot-scope="props">
                <b-table-column field="email" label="Epost" sortable>
                    {{ props.row.email }}
                </b-table-column>
                
                <b-table-column field="name" label="Navn" sortable>
                    {{ props.row.firstname + ' ' + props.row.lastname }}
                </b-table-column>

                <b-table-column field="companyId" label="Firmaid" sortable>
                    {{ props.row.companyId }}
                </b-table-column>

                <b-table-column field="companyName" label="Firmanavn" sortable>
                    {{ props.row.companyName }}
                </b-table-column>

                <b-table-column field="createdAt" label="Opprettet dato" sortable>
                    {{ props.row.created_at | moment("D. MMM YYYY") }}
                </b-table-column>

                <b-table-column field="admin" label="Administrator" sortable>
                    <b-icon pack="fa" icon="check-circle" v-if="props.row.isAdministrator"></b-icon>
                </b-table-column>

                <b-table-column field="functions">
                    <b-tooltip label="Rediger bruker">
                        <a class="button is-primary" @click="editUser(props.row)">
                            <b-icon pack="fa" icon="edit"></b-icon>
                        </a>
                    </b-tooltip> 
                    <b-tooltip type="is-danger" label="Slett bruker" style="margin-left: 8px">
                    <a class="button is-danger" @click="confirmDelete(props.row)">
                        <b-icon pack="fa" icon="trash"></b-icon>
                    </a> 
                    </b-tooltip>
                    <b-tooltip type="is-warning" label="Resett passord" style="margin-left: 8px">
                    <a class="button is-warning" alt="Send nytt passord" @click="sendUserPasswordReset(props.row)" :disabled="isLoadingReset">
                        <b-icon pack="fa" icon="unlock-alt"></b-icon>
                    </a>
                    </b-tooltip>
                </b-table-column>
            </template>

        </b-table>

    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UserModal from '@/components/user/UserModal.vue';

export default {
    
    data () {
        return {
            isModalActive: false,
            currentPage: 1,
            paginated: true,
            perPage: 50,
            filter: ''
        }
    },
    methods: {
        ...mapActions('users', ['getUsers', 'deleteUser', 'resetUserPassword']),
        createUser () {
            var user = {
                firstname: '',
                lastname: '',
                email: '',
                isAdministrator: false,
                companyId: ''
            }

            this.launchModal(user)
        },
        editUser (user) {
            this.launchModal(user)           
        },
        launchModal (user) {
            this.$buefy.modal.open({
                parent: this,
                component: UserModal,
                hasModalCard: true,
                props: {user: user, isNewUser: user.user_id === undefined}, 
            }) 
        },
        confirmDelete(user) {
            this.$buefy.dialog.confirm({
                title: 'Bekreft sletting av bruker',
                message: `Er du sikker på at du ønsker å <b>slette</b> brukerkontoen for ${user.firstname} ${user.lastname}`,
                confirmText: 'Slett bruker',
                cancelText: 'Avbryt',
                type: 'is-danger',
                hasIcon: false,
                onConfirm: () => this.deleteUser(user)
            });

        },
        async sendUserPasswordReset (user) {
            try {
                await this.resetUserPassword(user)
                this.popToast('Passord er resatt og sendt til kunde på epost.', 'is-success')
            }
            catch (error) {
                this.popToast('Noe gikk galt under resetting av passord. Kontakt administrator.', 'is-danger')
            }
        },
        popToast (message, type) {
            this.$buefy.toast.open({
                message: message,
                position: 'is-bottom',
                duration: 8000,
                type: type
            })
        }
    },
    computed: {
        ...mapGetters('users', ['users', 'loading', 'isLoadingReset']),
        filtered: function() {
            const filtered = this.users.filter(user => Object.keys(user).some(k => user[k].toString().includes(this.filter)))
            return filtered;
        }
    },
    mounted () {
        this.getUsers()
    }
}
</script>

<style lang="scss" scoped>
div.users {
    margin-top: 32px;
}
</style>

